module.exports = {
	"header": "Café Magazine launches Spotin shop ",
	"date": "2020/12/08",
	"imgSrc": "6.jpg",
	"imgAlt": "Café Magazine launches Spotin shop ",
	"ingress": "By: Dagens Media (in Swedish)",
	"externalLink": "https://www.dagensmedia.se/medier/tidskrifter/cafe-oppnar-e-butik-kop-gors-genom-klick-pa-artikelbilder/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/6/article.json
// module id = 96
// module chunks = 0